import Pagination from "../../../../material/pagination/Pagination";
import PaginationConfig from "../../../../material/pagination/PaginationConfig";
import route from "../../../../enum/route";
import Operator from "../../../../material/pagination/Operator";
import Intervention from "../../../../entity/emergency/Intervention";
import PaginationColumn from "../../../../material/pagination/PaginationColumn";
import QualityInspectionUtils from "../../../../entity/utils/emergency/QualityInspectionUtils";
import Type from "../../../../material/pagination/Type";
import EnumConfig from "../../../../material/pagination/EnumConfig";
import EnumOption from "../../../../material/pagination/EnumOption";
import QualityInspection from "../../../../entity/emergency/QualityInspection";
import {useNavigate} from "react-router";
import OrderBy from "../../../../material/pagination/OrderBy";

export default function ({companyId}) {
    const navigate = useNavigate();

    return (
        <Pagination
            paginationConfig={
                new PaginationConfig()
                    .setId("intervention-list")
                    .setUri("/service-data-repository/entrepreneur/pagination/emergency/intervention")
                    .setOnRowClicked(row => navigate(route.ARTISAN_EMERGENCY_INTERVENTION.replace(":token", row.intervention_token)))
                    .setFieldAsId("intervention_id")
                    .addFixedFilter("company_id", Operator.EQUALS, companyId)
                    .addFixedFilter("intervention_status", Operator.EQUALS, Intervention.STATUS_IN_PROGRESS)
                    .addFixedFilter("intervention_status", Operator.EQUALS, Intervention.STATUS_SUCCESS)
                    .addFixedFilter("intervention_invoice_status", Operator.EQUALS, "null")
                    .setSortBy("quality_inspection_current_step")
                    .setOrderBy(OrderBy.ASC)
                    .setHideToolbar(true)
                    .setPerPage(5)
                    .addPaginationColumn(
                        new PaginationColumn()
                            .setHeader("Dossier")
                            .setField("order_id")
                            .setType(Type.NUMBER)
                            .setDisableSearchOption(true)
                            .setDefaultWidth(0.1)
                    )
                    .addPaginationColumn(
                        new PaginationColumn()
                            .setHeader("Étape")
                            .setField("quality_inspection_current_step")
                            .setValueCompiler(row => QualityInspectionUtils.getCurrentStepAsBadge(row.quality_inspection_current_step, "small"))
                            .setType(Type.ENUM)
                            .setEnumConfig(
                                new EnumConfig()
                                    .setMultiple(true)
                                    .addOption(new EnumOption(QualityInspection.STEP_INITIALIZED, QualityInspectionUtils.getCurrentStepAsText(QualityInspection.STEP_INITIALIZED)))
                                    .addOption(new EnumOption(QualityInspection.STEP_APPOINTMENT, QualityInspectionUtils.getCurrentStepAsText(QualityInspection.STEP_APPOINTMENT)))
                                    .addOption(new EnumOption(QualityInspection.STEP_TRAVEL, QualityInspectionUtils.getCurrentStepAsText(QualityInspection.STEP_TRAVEL)))
                                    .addOption(new EnumOption(QualityInspection.STEP_PICTURE_BEFORE, QualityInspectionUtils.getCurrentStepAsText(QualityInspection.STEP_PICTURE_BEFORE)))
                                    .addOption(new EnumOption(QualityInspection.STEP_QUOTATION, QualityInspectionUtils.getCurrentStepAsText(QualityInspection.STEP_QUOTATION)))
                                    .addOption(new EnumOption(QualityInspection.STEP_CLIENT_SIGNATURE, QualityInspectionUtils.getCurrentStepAsText(QualityInspection.STEP_CLIENT_SIGNATURE)))
                                    .addOption(new EnumOption(QualityInspection.STEP_WORK, QualityInspectionUtils.getCurrentStepAsText(QualityInspection.STEP_WORK)))
                                    .addOption(new EnumOption(QualityInspection.STEP_PICTURE_AFTER, QualityInspectionUtils.getCurrentStepAsText(QualityInspection.STEP_PICTURE_AFTER)))
                                    .addOption(new EnumOption(QualityInspection.STEP_DELIVERY, QualityInspectionUtils.getCurrentStepAsText(QualityInspection.STEP_DELIVERY)))
                            )
                            .setDefaultWidth(0.2)
                    )
            }
        />
    )
}